module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_arrow_revious.f4358.png";